<template>
    <svg width="20" height="21" viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.692 12.918a2.585 2.585 0 1 0-2.584-2.584 2.591 2.591 0 0 0 2.584 2.584zm-5.3-8.267a7.285 7.285 0 0 1 3.1-1.68L8.526 0h2.585l1.033 2.971a9.02 9.02 0 0 1 3.1 1.68l3.1-.646 1.292 2.325-2.067 2.325c.107.553.15 1.117.13 1.68 0 .516-.13 1.162-.13 1.679l2.067 2.325-1.293 2.325-3.1-.646a7.285 7.285 0 0 1-3.1 1.68l-1.032 2.97H8.526l-1.033-2.97a9.021 9.021 0 0 1-3.1-1.68l-3.1.646L0 14.34l2.067-2.325a7.365 7.365 0 0 1-.13-1.68c0-.516.13-1.162.13-1.679L0 6.33l1.292-2.325 3.1.646z" fill="#1D1D1D" fill-rule="evenodd"/>
    </svg>
</template>

<script>
export default {
    name: 'IconSettings',
};
</script>
